import { VideoPlayer } from 'src/components/VideoPlayer';
import {
  ArticleContent,
  ArticleContentBlockTypes,
} from 'src/types/articleCmsTypes';

import {
  Image,
  MainIdea,
  ProductBanner as ProductBannerBlock,
  Quote,
  RichText,
  Title,
  WebinarBanner,
} from '../blocks';
import s from './ContentBlock.module.scss';

export function ContentBlock({ content }: { content: ArticleContent }) {
  const { blocks } = content;

  return (
    <div className={s.root}>
      {blocks &&
        blocks.map((block, index) => {
          switch (block.type) {
            case ArticleContentBlockTypes.Title:
              return <Title key={index} {...block} />;

            case ArticleContentBlockTypes.RichText:
              return <RichText key={index} {...block} />;

            case ArticleContentBlockTypes.RawHTML:
              return <RichText key={index} richText={block.html} />;

            case ArticleContentBlockTypes.Image:
              return <Image key={index} {...block} alt={block.alt ?? 'img'} />;

            case ArticleContentBlockTypes.MainIdea:
              return <MainIdea key={index} {...block} />;

            case ArticleContentBlockTypes.Quote:
              return <Quote key={index} {...block} />;

            case ArticleContentBlockTypes.ProductBanner:
              return <ProductBannerBlock key={index} {...block} />;

            case ArticleContentBlockTypes.WebinarBanner:
              return <WebinarBanner key={index} {...block} />;

            case ArticleContentBlockTypes.Video:
              return (
                <div className={s.padding}>
                  <VideoPlayer key={index} controls {...block} />
                </div>
              );
          }
        })}
    </div>
  );
}
